import React from "react";

import {
  CONFIGURATION_WEBHOOKS_RECEIVERS_PATH,
  MERGE_PRICING_PATH,
  openInNewTab,
} from "../../../../router/RouterUtils";
import { Button, Alert, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { Link } from "react-router-dom";

export const ThirdPartyWebhooksUpsellNoticeCard = () => {
  return (
    <Alert showWarningIcon color="blue">
      <div className="flex w-full flex-row items-center justify-between">
        <span>
          Your plan doesn't support <strong>Third-Party Webhooks</strong>. To add webhooks, upgrade
          to our <strong>Professional</strong> or <strong>Enterprise</strong> plan.
        </span>
        <Button
          size="sm"
          variant={ButtonVariant.TertiaryWhite}
          onClick={() => window.open(MERGE_PRICING_PATH, "_blank")}
        >
          View plans
        </Button>
      </div>
    </Alert>
  );
};

interface ThirdPartyWebhooksDisabledDueToSelectiveSyncFiltersNoticeCardProps {
  path: string;
}

export const ThirdPartyWebhooksDisabledDueToSelectiveSyncFiltersNoticeCard = ({
  path,
}: ThirdPartyWebhooksDisabledDueToSelectiveSyncFiltersNoticeCardProps) => {
  return (
    <Alert showWarningIcon color="blue">
      <div>
        Third-party webhooks are not available when <Link to={path}>Selective Sync filters</Link>{" "}
        are present.
      </div>
    </Alert>
  );
};

interface MustUseAutoWebhookSetupNoticeCardProps {
  integrationName: string;
}

export const MustUseAutoWebhookSetupNoticeCard = ({
  integrationName,
}: MustUseAutoWebhookSetupNoticeCardProps) => {
  return (
    <Alert showWarningIcon color="blue">
      <div className="flex w-full flex-row items-center justify-between">
        <span>
          Merge only supports <strong>Automatic Webhook Creation</strong> for {integrationName}.
          Enable this in{" "}
          <strong>
            Configuration {">"} Webhooks {">"} Receivers
          </strong>
          .
        </span>
        <Button
          size="sm"
          variant={ButtonVariant.TertiaryWhite}
          onClick={() => openInNewTab(CONFIGURATION_WEBHOOKS_RECEIVERS_PATH)}
        >
          Go to advanced configuration
        </Button>
      </div>
    </Alert>
  );
};
